import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-profil-utilisateur-card',
    templateUrl: './profil-utilisateur-card.component.html',
    styleUrls: ['./profil-utilisateur-card.component.scss'],
    imports: [
        CommonModule,
        RouterLink,
        MatIcon
    ]
})
export class ProfilUtilisateurCardComponent implements OnInit {
  @Input() title: string = '';
  @Input() icon: string = 'factory';
  @Input() bgColor: string = 'rougeNovo';
  @Input() textColor: string = 'white';
  @Input() data: string = 'test data';
  @Input() routerLink: string = '';
  @Output() cardClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onCardClick() {
    this.cardClick.emit();
  }
}
